import cmp from "./context/context";
import {CMP_ID, CMP_VERSION} from "./cmp/cmp";
import {EventManager} from "./api/event-manager";

class CmpStatus {

    private static DISPLAY_STATUS_VISIBLE   = 'visible';
    private static DISPLAY_STATUS_HIDDEN    = 'hidden';
    private static DISPLAY_STATUS_DISABLED  = 'disabled';

    private static CMP_STATUS_STUB      = 'stub';
    private static CMP_STATUS_LOADING   = 'loading';
    private static CMP_STATUS_LOADED    = 'loaded';
    private static CMP_STATUS_ERROR     = 'error';

    private static EVENT_STATUS_LOADED              = 'tcloaded';
    private static EVENT_STATUS_CMPUISHOWN          = 'cmpuishown';
    private static EVENT_STATUS_USERACTIONCOMPLETE  = 'useractioncomplete';

    private static _instance:CmpStatus;

    public static get instance() : CmpStatus
    {
        if (!CmpStatus._instance) {
            CmpStatus._instance = new CmpStatus();
        }
        return CmpStatus._instance;
    }

    private _cmpLoaded:boolean;
    private _cmpStatus:string;
    private _displayStatus:string;
    private _eventStatus:string;
    private _cmpConfigured:boolean;

    private constructor() {
        this._cmpLoaded = false;
        this._cmpStatus = CmpStatus.CMP_STATUS_STUB;
        this._displayStatus = CmpStatus.DISPLAY_STATUS_HIDDEN;
        this._eventStatus = '';
        this._cmpConfigured = false;
    }

    private defaultData() : void
    {
        this._cmpLoaded = false;
        this._cmpStatus = CmpStatus.CMP_STATUS_STUB;
        this._displayStatus = CmpStatus.DISPLAY_STATUS_HIDDEN;
        this._eventStatus = '';
        this._cmpConfigured = false;
    }

    private isStub() : boolean
    {
        return this._cmpStatus == CmpStatus.CMP_STATUS_STUB;
    }

    private isLoading() : boolean
    {
        return this._cmpStatus == CmpStatus.CMP_STATUS_LOADING;
    }

    private isReady() : boolean {
        return !this.isStub() && !this.isLoading();
    }

    public get cmpLoaded() : boolean
    {
        return this._cmpLoaded;
    }

    public get cmpConfigured() : boolean
    {
        return this._cmpConfigured;
    }

    public get eventStatus() : string
    {
        return this._eventStatus;
    }

    public get cmpStatus() : string
    {
        return this._cmpStatus;
    }

    public get displayStatus() : string
    {
        return this._displayStatus;
    }

    public get cmpId() : number|undefined
    {
        return this.isReady() ? CMP_ID : undefined;
    }

    public get cmpVersion() : number|undefined
    {
        return this.isReady() ? CMP_VERSION : undefined;
    }

    public get gvlVersion() : number|undefined
    {
        return this.isReady() ? cmp().vendorList?.version : undefined;
    }

    public get tfcPolicyVersion(): number|undefined {
        return this.isReady() ? cmp().vendorList?.policyVersion : undefined;
    }

    public startLoading() : void
    {
        this._cmpStatus = CmpStatus.CMP_STATUS_LOADING;
    }

    public finishLoad() : void
    {
        this._cmpStatus = CmpStatus.CMP_STATUS_LOADED;
        this._cmpLoaded = true;
        EventManager.trigger(EventManager.EVENT_CMP_READY);
        EventManager.trigger(EventManager.EVENT_CMP_LOADED);
    }

    public isShowingUI() : boolean
    {
        return this._displayStatus == CmpStatus.DISPLAY_STATUS_VISIBLE;
    }

    public mainLayerDisplayed() : void
    {
        this._displayStatus = CmpStatus.DISPLAY_STATUS_VISIBLE;
        this._eventStatus = CmpStatus.EVENT_STATUS_CMPUISHOWN;
    }

    public hideUI() : void
    {
        this._displayStatus = CmpStatus.DISPLAY_STATUS_HIDDEN;
    }

    public disableDisplay() : void
    {
        this._displayStatus = CmpStatus.DISPLAY_STATUS_DISABLED;
    }

    public errorCMP() : void
    {
        this._cmpStatus = CmpStatus.CMP_STATUS_ERROR;
    }

    public tcLoaded() : void
    {
        this._eventStatus = CmpStatus.EVENT_STATUS_LOADED;
        EventManager.trigger(EventManager.EVENT_CMP_GENERIC);
    }

    public userActionCompleted() : void
    {
        this._eventStatus = CmpStatus.EVENT_STATUS_USERACTIONCOMPLETE;
        EventManager.trigger(EventManager.EVENT_CMP_GENERIC);
        EventManager.trigger(EventManager.EVENT_CHANGED_CONFIG);

        if (!this._cmpConfigured) {
            this._cmpConfigured = true;
            EventManager.trigger(EventManager.EVENT_CMP_CONFIGURED);
        }
    }

    public configureCMP() : void
    {
        this._cmpConfigured = true;
        EventManager.trigger(EventManager.EVENT_CMP_CONFIGURED);
    }

    public restart() : void {
        this.defaultData();
    }
}

export default CmpStatus.instance;
